import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Layout from './components/layout';
import Home from './pages/home';
import Services from './pages/services';
import Category from './pages/category';
import TreatmentDetail from './pages/treatment-detail';
import Promotions from './pages/promotions';
import Facilities from './pages/facilities';
import Work from './pages/work';
import About from './pages/about';
import Pricing from './pages/pricing';
import Contact from './pages/contact';
import Booking from './pages/booking';

const App = () => (
  <BrowserRouter>
    <Routes>
      <Route element={<Layout />}>
        <Route path="/" element={<Home />} />
        <Route path="/servicios" element={<Services />} />
        <Route path="/servicios/:cat" element={<Category />} />
        <Route path="/servicios/:cat/:id" element={<TreatmentDetail />} />
        <Route path="/promociones" element={<Promotions />} />
        <Route path="/instalaciones" element={<Facilities />} />
        <Route path="/nuestros-trabajos" element={<Work />} />
        <Route path="/nosotros" element={<About />} />
        <Route path="/precios" element={<Pricing />} />
        <Route path="/contacto" element={<Contact />} />
        <Route path="/agendar" element={<Booking />} />
      </Route>
    </Routes>
  </BrowserRouter>
);

export default App;
